<template>
  <router-view />
</template>

<script>
export default {
  name: 'ArticleIndex'
}
</script>

<style scoped>
</style>

